import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.136 5.303a.75.75 0 011.061 0l4.167 4.167a.75.75 0 010 1.06l-4.167 4.167a.75.75 0 01-1.06-1.06l2.886-2.887H4.167a.75.75 0 110-1.5h9.856l-2.887-2.886a.75.75 0 010-1.061z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
